import { type FunctionComponent, } from "react";
import { createPortal, } from "react-dom";
import { CrossThin, } from "@icons";
import { useModalizeStore, } from "@components";
import { TermsAndServices, PrivacyPolicy, } from "@sections";
import "./ConnectionManager.scss";
import { CustomConnectButton } from "./CustomConnectButton";


export declare type ChooseWalletProps = {

};


export const ChooseWallet: FunctionComponent<ChooseWalletProps> = ({

}) => {

	const { modalize, } = useModalizeStore();
	const classes = () => [ "modal-el", "conn-man", "choose-wallet" ].join(" ");
	const root = document.querySelector("#modalRoot");

	const onTermsOfService = () => {
		modalize({ component: TermsAndServices, title: "Terms of service", blur: true, });
	}

	const onPrivacyPolicy = () => {
		modalize({ component: PrivacyPolicy, title: "Privacy Policy", blur: true, });
	}

	if( root ) {
		return createPortal (
			<div className={classes()}>
				<div className="panel">
					<div className="title">
						<div className="label"><h5>connect wallet</h5></div>
						<div className="button close"><CrossThin /></div>
					</div>
					<div className="main">
					    <CustomConnectButton />
					</div>
					<div className="footer">
					<div className="copy"><p>By connecting your wallet, you agree to our <a href="#" onClick={onTermsOfService}>Terms of Service</a> and consent to our <a href="#" onClick={onPrivacyPolicy}>Privacy Policy</a>.</p></div>
					</div>
				</div>
			</div>,
			root
		);
	}
	throw new Error("Failed with modal root.");
}
